import { useRef } from 'react';

/**
 * Focus return for modal surfaces opened programmatically (a row click, a
 * `confirmDestructive()` call). Radix returns focus to its <Trigger>; without
 * one it falls to <body>. This records whatever had focus when the surface
 * opened and puts focus back there on close.
 *
 * Spread the handlers onto Radix `Content`.
 */
export function useReturnFocus(explicit?: { current: HTMLElement | null }) {
  const opener = useRef<HTMLElement | null>(null);
  return {
    onOpenAutoFocus: () => {
      // Runs before focus moves into the content, so this is still the opener.
      opener.current = document.activeElement instanceof HTMLElement ? document.activeElement : null;
    },
    onCloseAutoFocus: (event: Event) => {
      const target = explicit?.current ?? opener.current;
      if (target?.isConnected) {
        event.preventDefault();
        target.focus();
      }
    },
  };
}
